import { Component, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NavHistoryService } from './services/nav-history.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  router = inject(Router);
  private navigation = inject(NavHistoryService);
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);
  private gtmService = inject(GoogleTagManagerService);

  title = 'app';
  apps = ['pp', 'aw', 'iw', 'lw', 'cm'];

  constructor() {
    this.navigation.startSaveHistory();
    this.apps.map(app => {
      this.matIconRegistry.addSvgIcon(
        `${app}_icon`,
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          `..${
            window.location.host.includes('localhost') ? '' : '/app'
          }/assets/${app}-icon.svg`
        )
      );
    });

    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url,
        };
        this.gtmService.pushTag(gtmTag);
      }
    });
  }
}
